import React from 'react'
import { connect } from "react-redux";
import { Select } from './FormElements';
import { switchLang } from '../core/redux/api/langs'

const mapStateToProps = state => {
    return {
        currentLang : state.rootReducer.currentLang || 1,
        fetchedLangs : state.rootReducer.fetchedLangs || []
    }
}

class LangSwitcher extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            (this.props.fetchedLangs && this.props.fetchedLangs.length > 1) && <Select
                value={this.props.currentLang}
                onChange={(value) => {this.props.switchLang(value)}}
                options={this.props.fetchedLangs}
                size="medium"
                uppercaseValue
                pink
            />
        )
    }
}

export default connect(mapStateToProps,{switchLang})(LangSwitcher);